import "react-native-gesture-handler";
import { useCallback, useEffect } from "react";
import * as SplashScreen from "expo-splash-screen";
import { Amplify } from "aws-amplify";
import awsConfig from "./src/aws-exports";
import * as Notifications from "expo-notifications";
import { useFonts } from "expo-font";
import WelcomeScreen from "./screens/WelcomeScreen";
import { Platform } from "react-native";

Notifications.setNotificationHandler({
  handleNotification: async () => ({
    shouldPlaySound: false,
    shouldSetBadge: false,
    shouldShowAlert: true,
  }),
});

//
// Amplify.configure(awsConfig);
// how does this work (what is analytics)
// Analytics MUST be disabled in order for the configuration to work
Amplify.configure({
  ...awsConfig,
  Analytics: {
    disabled: true,
  },
});
SplashScreen.preventAutoHideAsync();

function App() {
  const [fontsLoaded] = useFonts({
    "quicksand-bold": require("./assets/Quicksand-SemiBold.ttf"),
    "quicksand-normal": require("./assets/Quicksand-Regular.ttf"),
    fasthand: require("./assets/Fasthand-Regular.ttf"),
  });
  useCallback(() => {
    async () => {
      await SplashScreen.preventAutoHideAsync();
    };
  }, []);

  useEffect(() => {
    async function setUpPushNotifications() {
      const { status } = await Notifications.getPermissionsAsync();
      let finalStatus = status;

      if (finalStatus !== "granted") {
        const { status } = await Notifications.requestPermissionsAsync();
        finalStatus = status;
      }
      if (finalStatus !== "granted") {
        return;
      }
      if (Platform.OS === "android") {
        Notifications.setNotificationChannelAsync("default", {
          name: "default",
          importance: Notifications.AndroidImportance.MAX,
        });
      }
      return;
    }
    setUpPushNotifications();
  }, []);

  useEffect(() => {
    const initFunction = async () => {
      await SplashScreen.hideAsync();
    };
    initFunction();
  }, []);

  if (!fontsLoaded) {
    return null;
  } else {
    SplashScreen.hideAsync();
  }
  return <WelcomeScreen />;
}

export default App;
